import { GzRmTopIdentityRisksSeverityWidgetWebComponent } from './component/GzRmTopIdentityRisksSeverityWidgetWebComponent';

export { GzRmTopIdentityRisksSeverityWidgetWebComponent };
